var render = function render() {
  var _this$styleObj$invoic, _this$styleObj$invoic2, _vm$styleObj$invoiceC, _vm$styleObj$invoiceC2;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      position: "relative"
    },
    style: {
      "--color": _vm.themeColor
    },
    on: {
      click: function ($event) {
        return _vm.$emit("itemClick");
      }
    }
  }, [_c("div", {
    staticClass: "invoice"
  }, [_c("div", {
    staticClass: "selectBox invoiceType"
  }, [_c("span", {
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(_vm._s(_vm.$t("开具发票方式")))]), _c("a-select", {
    staticStyle: {
      width: "160px"
    },
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor,
    attrs: {
      placeholder: _vm.$t("请选择")
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "1"
    }
  }, [_vm._v(_vm._s(_vm.$t("多笔保单金额汇总开具发票")))]), _c("a-select-option", {
    attrs: {
      value: "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("多笔保单逐笔开具发票")))])], 1)], 1), _c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("发票信息")))]), _c("div", {
    staticClass: "selectBox"
  }, [_c("span", {
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(_vm._s(_vm.$t("抬头类型")))]), _c("a-select", {
    staticStyle: {
      width: "160px"
    },
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor,
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("抬头类型")
    },
    on: {
      change: _vm.invoiceHeadChange
    },
    model: {
      value: _vm.invoiceHeadType,
      callback: function ($$v) {
        _vm.invoiceHeadType = $$v;
      },
      expression: "invoiceHeadType"
    }
  }, [(_this$styleObj$invoic = this.styleObj.invoiceConfig) !== null && _this$styleObj$invoic !== void 0 && _this$styleObj$invoic.invoiceHeadType.includes("P") ? _c("a-select-option", {
    attrs: {
      value: "P"
    }
  }, [_vm._v(_vm._s(_vm.$t("个人")))]) : _vm._e(), (_this$styleObj$invoic2 = this.styleObj.invoiceConfig) !== null && _this$styleObj$invoic2 !== void 0 && _this$styleObj$invoic2.invoiceHeadType.includes("C") ? _c("a-select-option", {
    attrs: {
      value: "C"
    }
  }, [_vm._v(_vm._s(_vm.$t("公司")))]) : _vm._e()], 1)], 1), _vm.invoiceHeadType === "P" ? [_c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("发票内容")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("开票姓名")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("序号")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "itemBox",
    staticStyle: {
      "border-bottom": "20px solid #e8e8e8",
      height: "60px"
    }
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("金额")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])])] : _vm._e(), _vm.invoiceHeadType === "C" ? [_c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("发票抬头")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("纳税人识别号")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("发票内容")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("序号")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("金额")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "moreTips"
  }, [_c("b", [_vm._v(_vm._s(_vm.$t("更多信息")))]), _vm._v(" (" + _vm._s(_vm.$t("非必填")) + ") ")]), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("开户行名称")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("开户行帐号")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("公司联系电话")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("公司地址")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "itemBox",
    staticStyle: {
      "border-bottom": "20px solid #e8e8e8",
      height: "60px"
    }
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("备注信息")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])])] : _vm._e(), _c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("接收方式")))]), (_vm$styleObj$invoiceC = _vm.styleObj.invoiceConfig) !== null && _vm$styleObj$invoiceC !== void 0 && _vm$styleObj$invoiceC.invoiceSendMethod.includes("mobile") ? _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("手机号码")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]) : _vm._e(), (_vm$styleObj$invoiceC2 = _vm.styleObj.invoiceConfig) !== null && _vm$styleObj$invoiceC2 !== void 0 && _vm$styleObj$invoiceC2.invoiceSendMethod.includes("email") ? _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("电子邮箱")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]) : _vm._e()], 2), _c("div", [_vm._t("edit")], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };